import React from 'react';
import { Form, Input } from 'antd';
import cn from 'classnames';
import { Typography } from '_atoms/Typography';
import type { TextAreaProps } from './types';
import './style.scss';

const { TextArea: TextAreaAntd } = Input;

export const TextArea: React.FC<TextAreaProps> = ({
  className,
  value,
  onChange,
  label,
  required,
  optional,
  disabled,
  error,
  itemProps,
  maxLength,
  placeholder,
  autoFocus,
  onBlur,
  rows = 5,
  ...props
}) => (
  <div className={cn('textarea-default-wrapper', className, { error })}>
    {label && (
      <Typography.Label>
        {label}
        {!!required && <span className="required"> *</span>}
        {optional && <span className="optional"> (optional)</span>}
      </Typography.Label>
    )}
    <Form.Item {...itemProps}>
      <TextAreaAntd
        className="textarea-default"
        disabled={disabled}
        maxLength={maxLength ?? 2000}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        autoFocus={autoFocus}
        onBlur={onBlur}
        showCount
        rows={rows}
        {...props}
      />
    </Form.Item>
  </div>
);
